// extracted by mini-css-extract-plugin
module.exports = {"Masterpiece":"Masterpiece_Masterpiece__TWJka"};